import { FC, useEffect, useRef } from "react";
import styled from "styled-components";
import useSmoothAnchor from "lib/hooks/useSmoothAnchor";

const KeyVisual: FC = () => {
  const keyVisualRef = useRef<HTMLDivElement>(null);
  useSmoothAnchor("story");
  useSmoothAnchor("staff");
  useSmoothAnchor("record");
  useSmoothAnchor("announcement");
  useSmoothAnchor("initiativelist");
  useSmoothAnchor("distribution");
  useSmoothAnchor("merchandise");

  return (
    <Root ref={keyVisualRef}>
      <LogoArea>
        <Grad>
          <Menu>
            <MenuImage src="/image/lp/kaleido/bg/long/logo.png" alt="ロゴ" />
            <MenuItem href="#story">ストーリー</MenuItem>
            <MenuItem href="#staff">キャスト&スタッフ</MenuItem>
            <MenuItem href="#record">20周年の歩み</MenuItem>
            <MenuItem href="#announcement">お知らせ</MenuItem>
            <MenuItem href="#initiativelist">進行中の企画</MenuItem>
            <MenuItem href="#distribution">配信情報</MenuItem>
            <MenuItem href="#merchandise">グッズ</MenuItem>
          </Menu>
          <Logo />
          <LogoAnnouncementImage src="/image/lp/kaleido/announcement/menu.png" alt="アナウンスメント" />
          <LogoAnnouncementButtonImage href="#announcement">
            <img src="/image/lp/kaleido/announcement/button.png" alt="ボタン" />
          </LogoAnnouncementButtonImage>
        </Grad>
      </LogoArea>
    </Root>
  );
};
export default KeyVisual;

const Root = styled.section`
  @media screen and (max-width: 960px) {
    margin-bottom: 1vw;
  }
  @media screen and (min-width: 961px) {
    margin-bottom: 50px;
  }
`;
const Menu = styled.nav`
  position: absolute;
  top: 3vw;
  left: 15.2vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1;
  background-color: transparent;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;
const MenuImage = styled.img`
  width: 22vw;
  height: auto;
  margin-bottom: 3vw;
`;
const MenuItem = styled.a`
  cursor: pointer;
  color: #ba860a;
  text-decoration: none;
  font-size: 2.6vw;
  margin-bottom: 2.5vw;
  text-shadow: 0.3vw 0.3vw 0.6vw #fff, -0.3vw -0.3vw 0.6vw #fff, -0.3vw 0.3vw 0.6vw #fff, 0.3vw -0.3vw 0.6vw #fff;
  &:hover {
    text-decoration: underline;
  }
`;
const Grad = styled.div`
  @media screen and (min-width: 961px) {
    width: 100%;
    position: relative;
  }
`;
const LogoArea = styled.div`
  position: relative;
  
  @media screen and (min-width: 961px) {
    width: 100%;
  }
`;
const Logo = styled.div`
  background-image: url("/image/lp/kaleido/bg/long/key_visual_pc2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  padding-top: 50.505051%;
  position: relative;
  z-index: -1;

  @media screen and (max-width: 960px) {
    background-image: url("/image/lp/kaleido/bg/long/key_visual_sp.png");
    height: 138.157894737vw;
  }
`;
const LogoAnnouncementImage = styled.img`
  width: 100%;
  height: auto;
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
  }
`;
const LogoAnnouncementButtonImage = styled.a`
  display: none;
  width: 100%;
  height: auto;

  @media screen and (max-width: 960px) {
    display: block;
    margin-top: -17vw;
  }

  img {
    width: 100%;
    height: auto;
  }
`;
